import React, {PureComponent} from "react"

import {FormattedMessage} from "@irati/utils/lang"
import Hr from "@irati/ui/src/Layout/Hr"

import {Option} from "./index"
import {Tab, OptionTitle, OptionDescription, SelectedCard} from "./styled"

interface Props extends Option {
  selected: boolean,
  handleClick: () => void
}

class OptionTab extends PureComponent<Props> {
  preventOutline = (e) => {e.preventDefault()}

  render() {
    const {title, description, handleClick, selected} = this.props
    return (
      <Tab selected={selected} onMouseDown={this.preventOutline} onClick={handleClick} tabIndex={0}>
        <OptionTitle large bold center>
          <FormattedMessage id={title} />
        </OptionTitle>
        <Hr />
        <OptionDescription center>
          <FormattedMessage id={description} />
        </OptionDescription>
        {selected && <SelectedCard />}
      </Tab>
    )
  }
}

export default OptionTab
